<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center">Contents</h1>
<p class="center"><a href="#/xhtml/frantmatter02">Preface: Into the seventies</a></p>
<p class="center"><span href="#/xhtml/part01" title="Link target outside of Sample">Doing Sixty</span></p>
<p class="center"><span href="#/xhtml/endmatter01" title="Link target outside of Sample">Notes</span></p>
<p class="center" style="margin-top:30px;"><a href="#/42chap36">A Biography of Gloria Steinem</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?40ccf415